import { render, staticRenderFns } from "./ListSidebar.vue?vue&type=template&id=7bc0f0a0"
import script from "./ListSidebar.vue?vue&type=script&lang=js"
export * from "./ListSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports